export enum INPUT_TYPE {
    select = 'select',
    multiselect = 'multiselect',
    text = 'text',
    textarea = 'textarea',
    date = 'date',
    daterange = 'daterange',
    number = 'number',
}
